package com.milta.core.localization.translations.de

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Abbrechen",
    confirm = "Bestätigen",
    save = "Speichern",
    delete = "Löschen",
    back = "Zurück",
    loading = "Wird geladen…",
    retry = "Erneut versuchen",
    language = "Sprache",
    welcomeTitle = "Willkommen bei Milta",
    welcomeSubtitle = "Ihr intelligenter Zustellassistent",
    alreadyHaveAccount = "Ich habe bereits ein Konto",
    createAccount = "Konto erstellen",
    continueWithGoogle = "Weiter mit Google",
    continueWithApple = "Weiter mit Apple",
    oauthErrorGeneric = "Bei der Anmeldung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    oauthAppleWebComingSoon = "Die Anmeldung mit Apple ist im Web bald verfügbar.",
    oauthDriverAccountNotAllowedOnWeb = "Fahrerkonten können nicht auf das Web-Dashboard zugreifen. Bitte melden Sie sich über die mobile App an.",
    oauthAccountNotFoundOnWeb = "Für dieses Google-Konto wurde kein Milta-Konto gefunden.",
    errorOffline = "Keine Internetverbindung.",
    navTourneesDuJour = "Heutige Touren",
    navAjouterUneTournee = "Tour hinzufügen",
    navHistoriqueDesPreuves = "Zustellverlauf",
    navParametres = "Einstellungen",
    sidebarRoleManagerLabel = "Manager",
    noDeliveriesYetTitle = "Noch keine Lieferung",
    noDeliveriesYetSubtitle = "Tippen Sie auf „Lieferungen hinzufügen“, um welche hinzuzufügen",
    optimizationUnavailableExplanation = "Möchten Sie die Tour ohne Optimierung erstellen oder es erneut versuchen?",
    createWithoutOptimizationAction = "Ohne Optimierung erstellen",
    gpsAppSheetTitle = "Navigations-App auswählen",
    addressSearchingLabel = "Suche läuft…",
)
